import React, {useEffect, useState} from "react";
import {Card, Col, Descriptions, Row} from "antd";
import {Link} from "react-router-dom";
import {useRequest} from "ahooks";
import * as api from "../../../../apis/platforms/admin/index"
import EChartsReact from "echarts-for-react";
import html2canvas from "html2canvas";
import styles from "../../dealer/index/index.module.css";
import dayjs from "dayjs";
import * as bulletinApi from "../../../../apis/bulletin";
import DetailDrawer from "../../../bulletin/detailDrawer";


export default function Index() {

    const [todo, setTodo] = useState<any>({})
    const [chartTitles, setChartTitles] = useState<string[]>([]);
    const [chartAmounts, setChartAmounts] = useState<any[]>([]);
    const [bulletins, setBulletins] = useState<any[]>([]);
    const [selectedBulletin, setSelectedBulletin] = useState<any>(undefined);

    useEffect(() => {
        run()
    }, [])

    const {loading, run} = useRequest(api.getTodo, {
        manual: true,
        onSuccess: (res) => {
            setTodo(res.data.data)
        }
    })

    const {loading:loadingMonthData, run: runMonthData} = useRequest(api.getMonthData,{
        manual: false,
        onSuccess(res){
            const data=  res.data.data;
            const titles = [];
            const amounts = [];
            for (const item of data) {
                titles.push(item.type);
                amounts.push({value:item.value, label: {show: true, position: 'inside'}});
            }
            setChartTitles(titles);
            setChartAmounts(amounts);
        }
    });

    const {loading: loadingGetBulletin, runAsync: runGetBulletin} = useRequest(bulletinApi.getBulletinsList,{
        manual: false,
        defaultParams: [{page:1,limit:10}],
        onSuccess(res){
            setBulletins(res.data.data);
        }

    })

    const handleGenerateImage = ()=>{
        const container:HTMLDivElement = document.querySelector(`div.echarts-for-react`) as HTMLDivElement;
        if(container){
            html2canvas(container).then(canvas=>{
                const url = canvas.toDataURL('image/png');
                const a = document.createElement('a');
                a.href = url;
                a.download = '本月情况';
                a.click();
            })
        }
    }

    return (
        <div style={{padding: 15}}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Card title="待办事项" bordered={false} loading={loading}>
                        <Descriptions title="待处理" layout={"horizontal"}>
                            <Descriptions.Item label="待审核客户">
                                <Link to={'/customer/dealer?status=0'}>{todo?.waitApprovalDealerCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="待审核价格合同">
                                <Link to={'/contract/contract?status=0'}>{todo?.waitApprovalContractCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="超账期待确认">
                                <Link to={'/order/sales?status=10'}>{todo?.overduePendingSalesOrderCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="现款待付款">
                                <Link to={'/order/sales?status=40'}>{todo?.paymentPendingSalesOrderCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="预订单">
                                <Link to={'/order/presale?filter=1'}>{todo?.preOrderCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="缺货订单">
                                <Link to={'/order/stockout?filter=1'}>{todo?.outStockOrderCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="30天内证书到期客户">
                                <Link
                                    to={'/customer/dealer?expirationUpcoming=1'}>{todo?.expirationUpcomingDealerCount}</Link>
                            </Descriptions.Item>
                        </Descriptions>
                        <Descriptions title="本周新增数据" layout={"horizontal"}>
                            <Descriptions.Item label="商品">
                                <Link to={'/product/product?thisWeekNew=1'}>{todo?.thisWeekProductCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="客户">
                                <Link to={'/customer/dealer?thisWeekNew=1'}>{todo?.thisWeekDealerCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="价格合同">
                                <Link to={'/contract/contract?thisWeekNew=1'}>{todo?.thisWeekContractCount}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="订单">
                                <Link to={'/order/sales?thisWeekNew=1'}>{todo?.thisWeekSalesOrderCount}</Link>
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="公告" bordered={false} extra={<Link to={'/sys/bulletin'}>更多</Link>}>
                        <div className={styles.BulletinContainer}>
                            {
                                bulletins.map((b:any)=>(
                                    <p className={styles.Item} onClick={()=>setSelectedBulletin(b)}><span className={styles.Title}>{b.title}</span><span>{dayjs(b.publishTime).format('lll')}</span></p>
                                ))
                            }
                        </div>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="本月情况" bordered={false} loading={loadingMonthData} extra={<a onClick={handleGenerateImage}>生成图片</a>}>
                        <EChartsReact option={{
                            xAxis: {
                                type: 'category',
                                data: chartTitles
                            },
                            yAxis: {
                                type: 'value',
                            },
                            series: {
                                data: chartAmounts,
                                type: 'bar',

                            }
                        }}/>
                    </Card>
                </Col>
            </Row>
            <DetailDrawer visible={!!selectedBulletin} onClose={()=>setSelectedBulletin(undefined)} bulletin={selectedBulletin}/>
        </div>
    )
}
